export var themePlaceholder = '$';
export var templateThemeClassRef = function templateThemeClassRef(classRef) {
  return "" + themePlaceholder + classRef;
};
export var makeThemedClassReference = function makeThemedClassReference(themeRef, classRef) {
  return "" + classRef + themeRef;
};
export var convertToCssClass = function convertToCssClass(ref) {
  return "." + ref;
};